import * as api from "../api";
import {
  ActionType,
  QuestionData,
  SEPARATOR,
  SurveyColumn,
  ContactType,
  Slug,
  EducationCategories,
} from "../constants";
import { eduIdNotFound } from "../utils/actionUtils";
import { fixEduDescription } from "../utils/eduUtils";
import { formatJobDescription, throttle } from "../utils/utils";
import { logError } from "./ApiService";
import { setUserSession } from "./AuthService";

export const getSurvey = throttle(
  async (
    dispatch,
    {
      contactInfo,
      contactType,
      loginToken,
      targetContactInfo,
      targetContactType,
    },
    { handleFail = null, handleRequestFinish = null }
  ) => {
    try {
      const { data } = await api.adminSurveyData({
        contactInfo,
        contactType,
        loginToken,
        targetContactInfo,
        targetContactType,
      });
      console.log("adminSurveyData", data);
      if (data.success) {
        const {
          survey_data,
          user_info,
          contact_type: actualContactType,
        } = data.data;
        if (survey_data) {
          //   dispatch({
          //     type: ActionType.setUserData,
          //     payload: {
          //       contactInfo,
          //       contactType,
          //       loginToken,
          //       firstName: user_info.first_name,
          //       lastName: user_info.last_name,
          //       verified: user_info.verified,
          //       isAdmin: user_info.is_admin,
          //     },
          //   });
          //   setUserSession({
          //     contactInfo,
          //     contactType,
          //     loginToken,
          //     firstName: user_info.first_name,
          //     lastName: user_info.last_name,
          //   });
          console.log("got adminSurveyData", survey_data);
          const surveyPayload = {};
          QuestionData.forEach(
            ({ column, options, useInputText, isImportant }, i) => {
              // console.log(column, i)
              if (
                column === null ||
                survey_data[column] === undefined ||
                survey_data[column] === null
              )
                return;
              let columnData = survey_data[column].split(SEPARATOR);
              if (column === SurveyColumn.salary) {
                // convert to number
                columnData = columnData.map((s) => parseInt(s));
                //   dispatch({
                //     type: ActionType.updateDefaultSalaryIdx,
                //     payload: options.indexOf(columnData[0]) + 1,
                //   });
                surveyPayload[i] = columnData
                  .map((s, j) => options.indexOf(s) + 1)
                  .filter((s) => s !== -1);
              }
              if (useInputText) {
                surveyPayload[i] = columnData;
                return;
              }
              if (survey_data[column] !== "") {
                columnData.forEach((s, j) => {
                  if (options.indexOf(s) === -1) {
                    console.log(
                      "unknown survey data",
                      column,
                      s,
                      options.indexOf(s)
                    );
                  }
                });
              }
              surveyPayload[i] = columnData
                .map((s, j) => options.indexOf(s))
                .filter((s) => s !== -1);
              if (
                isImportant &&
                survey_data[column + "_important"] !== undefined &&
                survey_data[column + "_important"] !== null
              ) {
                surveyPayload["important" + i] = survey_data[
                  column + "_important"
                ]
                  .split(SEPARATOR)
                  .map((s, j) => options.indexOf(s))
                  .filter((s) => s !== -1);
              }
            }
          );
          // console.log('got survey data2', surveyPayload)
          dispatch({
            type: ActionType.adminSurveyFromServer,
            payload: surveyPayload,
            contactInfo: targetContactInfo,
            contactType: actualContactType,
          });
          if (handleRequestFinish) {
            handleRequestFinish();
          }
        }
      } else {
        if (handleRequestFinish) {
          handleRequestFinish();
        }
        return logError("adminSurveyData", data.error_code, dispatch);
      }
      return data;
    } catch (error) {
      if (handleFail) {
        handleFail();
      }
      if (handleRequestFinish) {
        handleRequestFinish();
      }
      return logError("adminSurveyData", error, dispatch);
    }
  },
  3000
);
